import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this._content = this.element.dataset.bsContent || ''
    this._isHtml = this.element.dataset.bsHtml === 'true'
    this._popover = null

    this._show = this._show.bind(this)
    this._hide = this._hide.bind(this)

    this.element.addEventListener('mouseenter', this._show)
    this.element.addEventListener('focus', this._show)
    this.element.addEventListener('mouseleave', this._hide)
    this.element.addEventListener('blur', this._hide)
  }

  disconnect () {
    this._hide()
    this.element.removeEventListener('mouseenter', this._show)
    this.element.removeEventListener('focus', this._show)
    this.element.removeEventListener('mouseleave', this._hide)
    this.element.removeEventListener('blur', this._hide)
  }

  _show () {
    if (this._popover || !this._content) return

    const el = document.createElement('div')
    el.className = 'stimulus-popover'
    el.style.cssText = [
      'position:absolute',
      'z-index:1070',
      'background:#fff',
      'border:1px solid rgba(0,0,0,.2)',
      'border-radius:4px',
      'padding:8px 12px',
      'max-width:276px',
      'font-size:14px',
      'line-height:1.5',
      'box-shadow:0 5px 10px rgba(0,0,0,.2)',
      'pointer-events:none',
    ].join(';')

    if (this._isHtml) {
      el.innerHTML = this._content
    } else {
      el.textContent = this._content
    }

    document.body.appendChild(el)
    this._popover = el
    this._reposition()
  }

  _hide () {
    this._popover?.remove()
    this._popover = null
  }

  _reposition () {
    if (!this._popover) return
    const { top, left, width } = this.element.getBoundingClientRect()
    const { offsetWidth: pw, offsetHeight: ph } = this._popover
    this._popover.style.top = `${top + window.scrollY - ph - 8}px`
    this._popover.style.left = `${left + window.scrollX + width - pw}px`
  }
}
